<template>
  <div class="modalTable">
    <vxe-toolbar>
      <template v-slot:buttons>
        <el-button type="primary" @click="funcFilter()">查询</el-button>
        <el-button type="primary" @click="getSelectEvent">确定</el-button>
        <el-tooltip
          class="item"
          effect="dark"
          content="首次使用的实际承运人，请先添加实际承运人信息"
          placement="top-start"
        >
          <el-button @click="addDriver">添加实际承运人</el-button>
        </el-tooltip>
        <span
          v-if="tooltipVisible"
          style="margin-left:15px;font-weight: bold;color:red;"
          >首次使用的实际承运人，请先添加实际承运人</span
        >
      </template>
    </vxe-toolbar>

    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      height="460"
      :loading="loading"
      :checkbox-config="{ highlight: true }"
      :data="tableData"
      row-id="code"
      align="center"
      auto-resize
      @checkbox-change="checkboxChangeEvent"
      @checkbox-all="selectAll"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column field="name" title="实际承运人姓名" min-width="130" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="实际承运人手机号"
          min-width="150"
        >
          <template #default="{ row }">
            {{ maskPhone(row.phone) }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="实际承运人手机号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLicenseNumber"
          title="车牌号"
          min-width="130"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLicenseNumber"
            placeholder="车牌号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="loadStatusName"
          title="负载状态"
          min-width="130"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.loadStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>

      <!-- <vxe-table-column>
        <vxe-table-column field="linkMan" title="车队名称" min-width="130" />
        <template v-slot:header>
          <el-input
            v-model="listQuery.linkMan"
            placeholder="车队名称"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="vehicleOutsideDimensions"
          title="外廓尺寸(mm)"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleOutsideDimensions"
            placeholder="外廓尺寸"
            clearable
            disabled
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleLoadWeightName"
          title="载重"
          min-width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.vehicleLoadWeightName"
            placeholder="载重"
            clearable
            disabled
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="vehicleClassificationName"
          title="车型"
          min-width="150"
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.vehicleClassificationCode"
            placeholder="请选择车辆类型"
            clearable
            filterable
          >
            <el-option
              v-for="item in vehicleClassificationList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
    </vxe-table>

    <vxe-pager
      :loading="loading"
      :page-sizes="Pagingconf"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <div class="tag_wrap">
      <div
        v-if="selectedDrivers.length > 0"
        style="margin-bottom: 10px;display: flex;flex-wrap: wrap;"
      >
        <span style="font-weight: bold; margin-right: 10px;"
          >已选择实际承运人：</span
        >
        <div v-for="(drivers, index) in selectedDrivers" :key="index">
          <el-tag
            v-for="driver in drivers"
            :key="driver.code"
            closable
            type="primary"
            style="margin-right: 8px; margin-bottom: 5px;"
            @close="removeDriver(driver)"
          >
            {{ driver.name }}
          </el-tag>
        </div>
      </div>
    </div>

    <vxe-modal
      v-model="showAdd"
      title="添加实际承运人"
      width="1000"
      height="700"
      resize
      @close="closeDatas()"
    >
      <DesignatedAdd
        v-if="showAdd"
        ref="Driver"
        @updateList="updateList"
        @close="showAdd = false"
      />
    </vxe-modal>
  </div>
</template>

<script>
import DesignatedAdd from "@/views/basicInfo/shipment/capacityCenter/components/DesignatedAdd.vue";
import { tedDriver } from "@/api/orderform";
import { acceptVehicleDriverList } from "@/api/orderform";
import { getListDict } from "@/api/commonApi";
export default {
  name: "Child",
  components: {
    DesignatedAdd
  },
  props: {
    branchCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showAdd: false,
      tooltipVisible: false,
      loading: false,
      tableData: [],
      selectedDrivers: [], // 新增：存储选中的实际承运人列表
      listQuery: {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        // driverType: "3",
        driverType: "6",
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassification: "",
        vehicleLoadStatus: "",
        isFreeze: "0",
        authStatus: "3",
        workStatus: "1",
        authStatusExt: "3",
        branchCodeExt: ""
      },
      // selectArrs: [],
      Pagingconf: [],
      selectRecords: [],
      vehicleClassificationList: [],
      options: [
        {
          value: "0",
          label: "空载"
        },
        {
          value: "1",
          label: "负载"
        }
      ]
    };
  },
  watch: {
    branchCode() {
      this.designcar();
    }
  },
  created() {
    getListDict({
      types: "vehicleClassification"
    }).then(response => {
      this.vehicleClassificationList = response.data.filter(
        item => item.type === "vehicleClassification"
      )[0]["dictList"];
    });
    this.designcar();
    this.$nextTick(() => {
      let show = localStorage.getItem("tooltipVisible") || false;
      if (!show) {
        this.tooltipVisible = true;
      } else {
        this.tooltipVisible = false;
      }
    });
  },
  methods: {
    updateList() {
      this.showAdd = false;
      this.findList();
    },
    addDriver() {
      this.tooltipVisible = false;
      localStorage.setItem("tooltipVisible", true);
      this.showAdd = true;
    },
    handlePageChange() {
      console.log("切换页数===", this.listQuery.pageNum);
      this.findList();
      //将本页所选中的数值，table赋值选中复选框
    },
    checkboxChangeEvent(event) {
      console.log("checkboxChangeEvent", this.$refs.xTable.getSelectRecords());
      // 更新选中的实际承运人列表
      let val = this.$refs.xTable.getSelectRecords();
      this.selectedDrivers[this.listQuery.pageNum - 1] = val;
      this.$forceUpdate();
      console.log("checkboxChangeEvent=========", this.selectedDrivers);
    },
    selectAll(event) {
      console.log("selectAll", event.records);
      // this.selectArrs = event.records;
      // 更新选中的实际承运人列表
      // this.selectedDrivers = event.records;
      this.selectedDrivers[this.listQuery.pageNum - 1] = event.records;
      this.$forceUpdate();

      console.log("selectAll=========", this.selectedDrivers);
    },
    closes() {
      this.listQuery = {
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0,
        driverType: "3",
        name: "",
        phone: "",
        headImg: "",
        linkMan: "",
        vehicleLicenseNumber: "",
        vehicleLength: "",
        vehicleClassification: "",
        vehicleLoadStatus: "",
        isFreeze: "0",
        authStatus: "3",
        workStatus: "1",
        authStatusExt: "3",
        branchCodeExt: ""
      };
      // console.log("1111111111", this.selectArrs);
      // this.selectArrs = [];
      this.selectedDrivers = []; // 清空选中的实际承运人列表
    },
    designcar(params) {
      if (this.branchCode) {
        this.listQuery.branchCodeExt = this.branchCode;
      }
      this.findList();
    },
    findList() {
      this.loading = true;
      // this.listQuery.isMasterBind = "1";
      acceptVehicleDriverList(this.listQuery).then(response => {
        this.loading = false;
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        response.data.total > 10000
          ? (this.Pagingconf = [20, 30, 50, 100, 10000])
          : (this.Pagingconf = [20, 30, 50, 100, response.data.total || 1]);
        this.$nextTick(() => {
          if (this.selectedDrivers[this.listQuery.pageNum - 1]) {
            console.log(
              "选中状态========",
              this.listQuery.pageNum - 1,
              this.selectedDrivers[this.listQuery.pageNum - 1]
            );
            // 先清除所有选中状态
            this.$refs.xTable.clearCheckboxRow();
            // 逐个设置选中状态，使用延时确保DOM更新完成
            setTimeout(() => {
              this.selectedDrivers[this.listQuery.pageNum - 1].forEach(
                driver => {
                  // 通过code字段匹配行数据
                  const targetRow = this.tableData.find(
                    row => row.code === driver.code
                  );
                  if (targetRow) {
                    this.$refs.xTable.setCheckboxRow(targetRow, true);
                  }
                }
              );
            }, 100);
          }
        });
      });
    },
    // 电话号码脱敏方法
    maskPhone(phone) {
      if (!phone) return "";
      const phoneStr = phone.toString();
      if (phoneStr.length === 11) {
        // 11位手机号：显示前3位和后4位，中间4位用*替换
        return phoneStr.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      } else if (phoneStr.length >= 7) {
        // 其他长度的电话号码：保留前3位和后4位，中间用*替换
        const start = phoneStr.substring(0, 3);
        const end = phoneStr.substring(phoneStr.length - 4);
        const middle = "*".repeat(phoneStr.length - 7);
        return start + middle + end;
      }
      return phoneStr; // 长度不足7位的直接返回原值
    },
    getSelectEvent() {
      let selectRecords = this.selectedDrivers.flat();
      console.log("selectRecords=======", this.selectedDrivers.flat());
      if (selectRecords.length > 0) {
        this.$emit("event", selectRecords, 0);
      } else {
        this.$message({ message: "请至少选择一个实际承运人", type: "warning" });
      }
    },
    // 删除选中的实际承运人tag
    removeDriver(driver) {
      console.log(
        "this.selectedDrivers======",
        this.selectedDrivers,
        "页数",
        this.listQuery.pageNum
      );
      // const index = this.selectedDrivers[this.listQuery.pageNum - 1].findIndex(
      //   item => item.code === driver.code
      // );
      // console.log("查找坐标=====", index);
      // if (index > -1) {
      //   this.selectedDrivers[this.listQuery.pageNum - 1].splice(index, 1);
      // }
      // 使用 map 和 filter 创建新数组
      this.selectedDrivers = this.selectedDrivers.map(innerArray => {
        return innerArray.filter(obj => obj.code !== driver.code);
      });
      this.$forceUpdate();

      // 取消table中对应行的选中状态
      this.$refs.xTable.setCheckboxRow(driver, false);

      // 同步更新selectArrs
      // const selectIndex = this.selectArrs.findIndex(
      //   item => item.code === driver.code
      // );
      // if (selectIndex > -1) {
      //   this.selectArrs.splice(selectIndex, 1);
      // }
    }
  }
};
</script>

<style scoped>
.tag_wrap {
  margin-top: 10px;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  /* 禁止选中 */
  user-select: none;
}
</style>
